import React, { FC } from 'react';
import { Icon } from 'antd';
import { InternalServerErrorAlert } from '../../../components';
import { useCountLocationsInOrganizationQuery } from '../hooks/useCountLocationsInOrganizationQuery';

interface Props {
  organizationId: string;
}

export const ActiveLocationCount: FC<Props> = ({ organizationId }): JSX.Element => {
  const { data, loading, error } = useCountLocationsInOrganizationQuery({
    variables: {
      organizationId,
    },
    fetchPolicy: 'no-cache',
  });

  if (error) return <InternalServerErrorAlert error={error} />;

  if (loading || !data) {
    return <Icon type="loading" />;
  }

  const { countLocationsInOrganization: count } = data;

  return <>{count}</>;
};
